export class SetToken {
  public static readonly type = '[Auth] Set Token'

  constructor(
    /** JWT token */
    public token: string,
    /** Authentication mode, will be used to set which header to use */
    public mode: 'clerk' | 'legacy' = 'legacy'
  ) {}
}

export class LoginFromStorage {
  public static readonly type = '[Auth]  Login from storage'
}

export class Logout {
  public static readonly type = '[Auth] Logout'
}
